import React from 'react';
import ChooseAccountsStep from 'components/AccountConnectionFlow/ChooseAccountsStep';

const ActivateBingAdsAccountsStep = (props) => {
  return <ChooseAccountsStep />;
};

export default ActivateBingAdsAccountsStep;
